import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from './icon';
import { DeviceStatusList } from '../features/queues/components/device-status/device-status-list';
import styled from 'styled-components';
import { RootState } from '../root-reducer';
import { colors } from '@nextinq/ui-toolkit';

const Container = styled.section`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: max-content max-content 1fr;
  align-items: center;
`;
const NavTrigger = styled.section`
  padding: 9px 18px;
  cursor: pointer;
`;
const SettingsSection = styled.section``;
const DeviceStatusSection = styled.section``;
const TitleSection = styled.h3`
  justify-self: center;
  color: ${colors.grey.grey};
`;

export interface AppNavProps {
  onNavIconClick: () => void;
}

export function AppNav(props: AppNavProps) {
  const boothName = useSelector((s: RootState) => s.queues.boothName);
  return (
    <Container>
      <SettingsSection>
        <NavTrigger onClick={props.onNavIconClick}>
          <Icon size="large" name="bars" disabled />
        </NavTrigger>
      </SettingsSection>
      <DeviceStatusSection>
        <DeviceStatusList />
      </DeviceStatusSection>
      <TitleSection>{boothName}</TitleSection>
    </Container>
  );
}
